import React from 'react';
import PropTypes from 'prop-types';
import {sizes} from '../../styles/components/media-queries';
import {BannerLink, BannerWrapper, BannerImage} from './PromoBanner.style';

const PromoBanner = ({link, desktopImage, mobileImage, alt, className}) => {
  const picture = (
    <picture>
      <source media={`(max-width: ${sizes.small}px)`} srcSet={mobileImage} />
      <BannerImage src={desktopImage} alt={alt} $isLink={!!link} />
    </picture>
  );

  if (!link) {
    return <BannerWrapper className={className}>{picture}</BannerWrapper>;
  }

  return (
    <BannerLink to={link} className={className}>
      {picture}
    </BannerLink>
  );
};

PromoBanner.propTypes = {
  link: PropTypes.string,
  desktopImage: PropTypes.string.isRequired,
  mobileImage: PropTypes.string.isRequired,
  alt: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default PromoBanner;
